<template>
    <div class="" style="margin-top: 20px">
        <el-pagination
            style="text-align: center"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page.sync="currentPage3"
            prev-text="上一页"
            next-text="下一页"
            :page-size="10"
            layout="prev, pager, next, jumper"
            background
            :total="40"
        >
        </el-pagination>
    </div>
</template>
<script>
export default {
    methods: {
        handleSizeChange(val) {
        },
        handleCurrentChange(val) {
        },
    },
    data() {
        return {
            currentPage3: 1,
        };
    },
};
</script>
<style>
.el-pagination.is-background .el-pager li:not(.disabled).active {
    background-color: #e14d29;
}
.el-pager,
.el-pagination.is-background .btn-next,
.el-pagination.is-background .btn-prev {
    padding: 0 10px;
}
.el-pagination.is-background .btn-next,
.el-pagination.is-background .btn-prev,
.el-pagination.is-background .el-pager li {
    background: #fff;
}
</style>
